import React, { useCallback, useEffect, useState, useRef } from "react";
import PropTypes from "prop-types";
import "./MultiRangeSlider.css";
import jetcb from "./images/jetcb.png";
import blueend from "./images/blueend.png";
import redend from "./images/redend.png";

const MultiRangeSlider = ({ min, max, onChange, minValue, maxValue }) => {
  const [minVal, setMinVal] = useState(minValue);
  const [maxVal, setMaxVal] = useState(maxValue);

  // Get min and max values when their state changes
  useEffect(() => {
    onChange({ minValue: minVal, maxValue: maxVal });
  }, [minVal, maxVal, onChange]);

  return (
    <div className="container">
      <input
        type="range"
        min={min}
        max={max}
        value={minVal}
        onChange={(event) => {
          const value = Math.min(Number(event.target.value), maxVal - 1);
          setMinVal(value);
          // minValRef.current = value;
        }}
        className="thumb thumb--left"
        style={{ zIndex: minVal > max - 100 && "5" }}
      />
      <input
        type="range"
        min={min}
        max={max}
        value={maxVal}
        onChange={(event) => {
          const value = Math.max(Number(event.target.value), minVal + 1);
          setMaxVal(value);
          // maxValRef.current = value;
        }}
        className="thumb thumb--right"
      />

      <div className="slider">
        <div className="slider__range" >
          <div style={{ padding: "0px", display: 'flex' }}>

            <img src={blueend} style={{
              height: '13px',
              width: (minVal / 255) * 100 + '%',
              borderRadius: '10px',
              marginTop: '-4px'
            }} alt="bbar" />

            <img src={jetcb} style={{
              height: '13px',
              width: ((maxVal - minVal) / 255) * 100 + '%',
              borderRadius: '10px',
              marginTop: '-4px'
            }
            } alt="cbar" />

            <img src={redend} style={{
              height: '13px',
              width: ((255 - maxVal) / 255) * 100 + '%',
              borderRadius: '10px',
              marginTop: '-4px'
            }} alt="rbar" />
          </div>
        </div>
        <div className="slider__left-value">{minVal}</div>
        <div className="slider__right-value">{maxVal}</div>
      </div>
    </div>
  );
};

MultiRangeSlider.propTypes = {
  min: PropTypes.number.isRequired,
  max: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  minValue: PropTypes.number.isRequired,
  maxValue: PropTypes.number.isRequired
};

export default MultiRangeSlider;
